import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  navigation: {
    display: "flex",
    alignItems: "center",
    marginBottom: 10
  },
  navigationTitle: {
    fontSize: 14,
    marginLeft: 12
  },
  dates: {
    display: "flex",
    paddingBottom: 24,
    gap: 12
  },
  dateBox: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    cursor: "pointer",
    maxWidth: "calc(50% - 6px)"
  },
  dateTitle: {
    fontSize: 12,
    color: theme.palette.text.secondary
  },
  date: {
    color: "#1a1a1a",
    fontSize: 14
  },
  calendarIcon: {
    width: 9,
    height: 10,
    marginRight: 6
  },
  pickingFrom: {
    "& $calendarEndDate": {
      backgroundColor: "#000000",
      color: theme.palette.common.white
    },
    "& $calendarStartDate": {
      backgroundColor: theme.palette.secondary.main,
      color: "#1a1a1a"
    },
    "& $calendarOneDayRange": {
      backgroundColor: theme.palette.secondary.main,
      color: "#1a1a1a"
    }
  },
  pickingTo: {
    "& $calendarEndDate": {
      backgroundColor: theme.palette.secondary.main,
      color: "#1a1a1a"
    },
    "& $calendarStartDate": {
      backgroundColor: "#000000",
      color: theme.palette.common.white
    },
    "& $calendarOneDayRange": {
      backgroundColor: theme.palette.secondary.main,
      color: "#1a1a1a"
    }
  },
  dayNames: {
    display: "flex",
    alignItems: "center",
    margin: "16px 0"
  },
  dayName: {
    fontSize: 10,
    color: theme.palette.text.secondary,
    width: "calc(100% / 7)",
    textAlign: "center",
    textTransform: "uppercase"
  },
  calendar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center"
  },
  calendarDate: {
    width: "calc(100% / 7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
    position: "relative",
    color: "#1a1a1a",
    height: 28,
    lineHeight: "28px"
  },
  calendarDateInner: {},
  calendarDateButton: {
    minWidth: 0,
    padding: 0,
    width: 28,
    height: 28,
    borderRadius: "50%",
    fontSize: 13,
    "&:hover": {
      backgroundColor: theme.palette.secondary.main
    }
  },
  calendarDateInRange: {
    color: "#1a1a1a",
    backgroundColor: "rgba(3, 243, 178, 0.2)",
    flex: "auto",
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  calendarEdge: {
    zIndex: 1,
    "&:hover": {
      color: "#1a1a1a",
      backgroundColor: theme.palette.secondary.main
    }
  },
  calendarStartDate: {},
  calendarEndDate: {},
  calendarOneDayRange: {},
  calendarDateBg: {
    width: "50%",
    backgroundColor: "rgba(3, 243, 178, 0.2)",
    height: 20,
    top: 4,
    position: "absolute"
  },
  calendarDateBgLeft: {
    left: 0
  },
  calendarDateBgRight: {
    right: 0
  },
  activeDatePreview: {
    color: theme.palette.secondary.dark,
    borderBottom: `1px solid ${theme.palette.secondary.dark}`
  }
}));
